module.exports = __webpack_public_path__ + "img/43ac308.png";